import { Link } from 'react-router-dom';
import { useAuthStore } from '../../stores/auth';
import { useTranslation } from 'react-i18next';

/**
 * Подтверждение почты нужно для всего, что тратит единицы
 * (agents/api-auth-consent.md §2). Напоминаем, но не блокируем интерфейс.
 */
export function VerifyEmailBanner() {
  const { t } = useTranslation();
  const user = useAuthStore((state) => state.user);
  if (!user || user.emailVerified) return null;

  return (
    <div className="mb-6 flex flex-wrap items-center gap-x-3 gap-y-1 rounded-control border border-warning/40 bg-surface-secondary px-4 py-3 text-body">
      <span className="text-content">{t('auth.verifyBanner')}</span>
      <Link to="/verify-email" className="text-accent hover:text-accent-hover">{t('auth.resendEmail')}</Link>
    </div>
  );
}
